import { ReactNode, useState, useMemo } from 'react';
import { PrivateRoute } from '../../router/restricted-routes-wrapper.tsx';
import cn from 'classnames';
import { useThemeContext } from '@utils/hooks/use-theme-context.ts';
import { css, StyleSheet } from 'aphrodite';
import TopNav from '@components/layout/navbar/top-nav.tsx';
import PageErrorBoundary from '@components/layout/page-error-boundary.tsx';

interface Props {
  layoutType?: 'main' | 'editor';
  children: ReactNode;
}

export default function PaymentPageWrapper(props: Props) {
  const { getColour } = useThemeContext();
  const [, setSidebarOpen] = useState(false);

  const styles = useMemo(
    () =>
      StyleSheet.create({
        main: {
          backgroundColor: getColour('baseLayer'),
          color: getColour('normalText')
        }
      }),
    [getColour]
  );

  return (
    <PrivateRoute>
      <TopNav setSidebarOpen={setSidebarOpen} />
      <div
        className={cn('w-full flex flex-row', css(styles.main))}
        style={{
          height: 'calc(100vh - 4rem)'
        }}
      >
        <main className={cn('h-full w-full overflow-y-auto flex flex-col')}>
          <PageErrorBoundary>{props.children}</PageErrorBoundary>
        </main>
      </div>
    </PrivateRoute>
  );
}
